@import "node_modules/@se/web-ui/styles/_theme.scss";

$tablet: map-get($breakpoints, tablet);

.show-more {
  &__container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 16px 12px;
    @media (min-width: $tablet) {
      padding: 16px;
    }
  }
  &__button {
    cursor: pointer;
  }

  &__text {
    font-size: 12px;
  }

  &__arrow {
    display: block;
    position: absolute;
    height: 14px;
    width: 14px;
    border-top: 3px solid $se-white;
    border-left: 3px solid $se-white;
    transform: rotate(45deg);
    top: 17px;
    border-radius: 2px;
  }

  &__go-top {
    display: flex;
    position: fixed;
    bottom: 20px;
    right: 22px;
    height: 48px;
    width: 48px;
    border: 3px solid $se-anthracite-grey;
    border-radius: 50%;
    box-shadow: 0px 10px 15px 0px rgba(112, 112, 112, 0.16);
    transition: 0.3s ease-out;
    justify-content: center;
    align-items: center;
    background-color: $se-anthracite-grey;
    cursor: pointer;
    z-index: 9999;
  }
}

.pagination__container {
  display: flex;
  justify-content: center;
  margin: 8px;
}
